__turbopack_context__.v({
  "root": "style-module-scss-module__tyBj_a__root",
  "text": "style-module-scss-module__tyBj_a__text",
});
